import { computed, reactive } from 'vue'
import de from '../locales/de.json'
import en from '../locales/en.json'
import type { Locale } from './types'

const messages = { de, en }
export type MessageKey = keyof typeof de

const initialLocale = (): Locale => {
  const saved = localStorage.getItem('ci.locale')
  if (saved === 'de' || saved === 'en') return saved
  return navigator.language.toLowerCase().startsWith('de') ? 'de' : 'en'
}

export const i18n = reactive({ locale: initialLocale() })

export const locale = computed(() => i18n.locale)

export function setLocale(next: Locale): void {
  i18n.locale = next
  localStorage.setItem('ci.locale', next)
  document.documentElement.lang = next
}

export function t(
  key: MessageKey,
  params: Record<string, string | number> = {},
): string {
  const table = messages[i18n.locale] as Record<string, string>
  let value = table[key] ?? key
  for (const [name, replacement] of Object.entries(params)) {
    value = value.replaceAll(`{${name}}`, String(replacement))
  }
  return value
}

export function formatNumber(value: number, maximumFractionDigits = 0): string {
  return new Intl.NumberFormat(i18n.locale, { maximumFractionDigits }).format(
    value,
  )
}

export function collator(): Intl.Collator {
  return new Intl.Collator(i18n.locale, {
    usage: 'sort',
    sensitivity: 'base',
    numeric: true,
  })
}

export function initializeI18n(): void {
  document.documentElement.lang = i18n.locale
  document.documentElement.dir = 'ltr'
}
